import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";
import { PAGE_SIZE } from "../../utils/contrains";
class QuailtyManualLink extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    manual: PropTypes.object.isRequired,
  };
  state = {
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    items: [
      {
        Id: 1,
        Type: "校內",
        LinkName: "課程地圖系統",
        LinkUrl: "https://coursemap.tut.edu.tw/SchoolClientViews",
        Description: "",
      },
      {
        Id: 2,
        Type: "校內",
        LinkName: "校務研究資訊平台",
        LinkUrl: "https://creditpgrm.tut.edu.tw/",
        Description: "",
      },
      {
        Id: 3,
        Type: "校內",
        LinkName: "各系科目表首頁（中英對照版）",
        LinkUrl: "https://subject.tut.edu.tw/Subject_View_AllSchool_2.aspx",
        Description: "",
      },
      // {
      //   Id: 4,
      //   Type: "校內",
      //   LinkName: "B005-師生競賽成果管理系統",
      //   LinkUrl: "https://nic141.tut.edu.tw/",
      //   Description: "",
      // },
      // {
      //   Id: 5,
      //   Type: "校內",
      //   LinkName: "E002-在校生專業證照登錄系統",
      //   LinkUrl: "https://cert.tut.edu.tw/",
      //   Description: "",
      // },
      // {
      //   Id: 6,
      //   Type: "校內",
      //   LinkName: "E009-畢業生流向調查系統",
      //   LinkUrl: "https://surveygraduateui.tut.edu.tw/",
      //   Description: "",
      // },
      {
        Id: 4,
        Type: "校外",
        LinkName: "UCAN大專院校職能平台",
        LinkUrl: "https://ucan.moe.edu.tw/",
        Description: "",
      },
      {
        Id: 5,
        Type: "校外",
        LinkName: "104升學就業地圖",
        LinkUrl: "https://guide.104.com.tw/career/school/5103000000/",
        Description: "",
      },
      {
        Id: 6,
        Type: "校外",
        LinkName: "教育部統計處",
        LinkUrl: "https://stats.moe.gov.tw/statedu/platform.aspx",
        Description: "",
      },
      {
        Id: 7,
        Type: "校外",
        LinkName: "104工作世界",
        LinkUrl: "https://guide.104.com.tw/wow/",
        Description: "",
      },
      {
        Id: 8,
        Type: "校外",
        LinkName: "104薪資情報",
        LinkUrl: "https://guide.104.com.tw/salary/",
        Description: "",
      },
      {
        Id: 9,
        Type: "校外",
        LinkName: "104課程情報",
        LinkUrl: "https://nabi.104.com.tw/course",
        Description: "",
      },
      {
        Id: 10,
        Type: "校外",
        LinkName: "104證照中心",
        LinkUrl: "https://nabi.104.com.tw/certify",
        Description: "",
      },
      {
        Id: 11,
        Type: "校外",
        LinkName: "1111證照中心",
        LinkUrl: "https://www.1111edu.com.tw/licence_index.php",
        Description: "",
      },
      {
        Id: 12,
        Type: "校外",
        LinkName: "台灣知識庫-全國碩士班",
        LinkUrl: "https://www.daso.com.tw/brochure/index",
        Description: "",
      },
      {
        Id: 13,
        Type: "校外",
        LinkName: "口碑聲量排名大學校系",
        LinkUrl: "https://dailyview.tw/top100/topic/145",
        Description: "",
      },
    ],
    columns: [
      {
        title: "編號",
        render: (item) => {
          const { Id } = item;
          return <div className="text-center">{Id}</div>;
        },
      },
      {
        title: "分類",
        render: (item) => {
          const { Type } = item;
          return <div className="text-center">{Type}</div>;
        },
      },
      {
        title: "資料來源系統名稱",
        render: (item) => {
          const openInNewTab = (url) => {
            window.open(url, "_blank", "noopener,noreferrer");
          };
          const { LinkName, LinkUrl } = item;
          return (
            <button
              onClick={() => openInNewTab(LinkUrl)}
              style={{ width: "100%", textAlign: "left" }}
              className="btn btn-link"
            >
              {LinkName}
            </button>
          );
        },
      },
    ],
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { items, columns } = this.state;
    return (
      <Card>
        <Table dataSource={items} columns={columns} pagination={true} />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(QuailtyManualLink);
